import React, { useState, useEffect } from 'react';
import { Input, Tabs, Button, Modal, Form, Dropdown, Menu as AntMenu, Grid, Table } from 'antd';
import { MoreOutlined, EllipsisOutlined, EyeOutlined, DownloadOutlined, PrinterOutlined, } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import Menu from '../../components/Menu/Menu';
import './Lists.scss';
import MobileMenu from "../../components/Menu/MobileMenu";
import Header from '../../components/Header/Header';
import { listService } from "../../services/ListService";
import { useLocation } from 'react-router-dom';
import ListStatusGuard from './ListStatusGuard';
import StatusTag from '../../components/StatusTag/StatusTag';

const { Search } = Input;
const VerticalDotsIcon = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="currentColor"
        style={{ cursor: 'pointer' }}
    >
        <circle cx="12" cy="5" r="2" />
        <circle cx="12" cy="12" r="2" />
        <circle cx="12" cy="19" r="2" />
    </svg>
);

const ArchivedLists = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.md;

    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [lists, setLists] = useState([]);
    const [counts, setCounts] = useState({});

    const pathToKey = {
        '/liste-necesar': 'creeaza',
        '/gata-de-trimis': 'gata',
        '/liste-in-ofertare': 'ofertare',
        '/liste-ofertate': 'ofertate',
        '/procesare-manuala': 'procesareManuala',

        '/liste-arhivate': 'arhivate',
    };
    const selectedMenuKey = pathToKey[location.pathname];

    const handleMenuClick = (key, record) => {
        const canViewOffers = ListStatusGuard.canFinalValidate(record.status);

        switch (key) {
            case 'vezi':
                if (!canViewOffers) {
                    return;
                }
                navigate(`/liste-ofertate/verificare-finala/${record.id}`);
                break;
            case 'descarca':
                // Add your logic to download PDFs
                console.log('Descarcă PDF-urile pentru lista:', record.id);
                break;
            case 'printeaza':
                // Add your logic to print PDFs
                console.log('Printează PDF-urile pentru lista:', record.id);
                break;
            default:
                break;
        }
    };

    useEffect(() => {

        listService.getCounts()
            .then(res => {
                if (res.data) {
                    setCounts(res.data.list_counts);

                }
            })
            .catch(err => {
                console.error("Eroare la încărcarea listelor:", err);
            });

    }, []);
    useEffect(() => {
        handleSearch('');

        listService.getLists('archived')
            .then(res => {
                if (res.data) {
                    setLists(res.data.necessity_lists);
                }
            })
            .catch(err => {
                console.error("Eroare la încărcarea listelor:", err);
            });
    }, []);


    const handleSearch = (value) => {
        setSearchQuery(value);
        if (value.length > 0) {
            listService.searchList(value, 1, 'archived')
                .then(res => {
                    if (res.data?.necessity_lists) {
                        setSearchResults(res.data.necessity_lists);
                    } else {
                        setSearchResults([]);
                    }
                })
                .catch(err => {
                    console.error("Eroare la căutare:", err);
                    setSearchResults([]);
                });
        } else {
            setSearchResults([]);
        }
    };




    const listColumns = [
        {
            title: 'Număr listă',
            dataIndex: 'id',
            key: 'id',
            width: 100,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status) => <StatusTag status={status} />

        },
        {
            title: 'Creata la',
            dataIndex: 'created_at',
            key: 'created_at',
            width: 140,
            render: (value) => new Date(value).toLocaleDateString('ro-RO'),
        },
        {
            title: 'Ofertata pe',
            dataIndex: 'programmed_date',
            key: 'programmed_date',
            width: 120,
            render: (value) => new Date(value).toLocaleDateString('ro-RO'),

        },
        {
            title: 'Timp ofertare',
            dataIndex: 'programmed_date',
            key: 'programmed_date',
            width: 120,
            render: (value) => new Date(value).toLocaleDateString('ro-RO'),

        },
        {
            title: 'Ofertanti',
            dataIndex: 'programmed_date',
            key: 'programmed_date',
            width: 120,
            render: (value) => new Date(value).toLocaleDateString('ro-RO'),

        },
        {
            title: 'Produse ofertate',
            dataIndex: 'bidding_stats',
            key: 'bidding_stats',
            width: 140,
            render: (_, record) => {
                const { items_with_bids, total_items } = record.bidding_stats || {};
                return `${items_with_bids} / ${total_items}`;
            }
        },

        {
            title: 'Acțiuni',
            key: 'actions',
            width: 100,
            render: (_, record) => {
                const menu = (
                    <AntMenu
                        onClick={({ key }) => handleMenuClick(key, record)}
                        items={[
                            {
                                key: 'vezi',
                                label: 'Vezi oferte',
                                icon: <EyeOutlined />,
                            },
                            {
                                key: 'descarca',
                                label: 'Descarcă PDF-urile',
                                icon: <DownloadOutlined />,
                            },
                            {
                                key: 'printeaza',
                                label: 'Printează PDF-urile',
                                icon: <PrinterOutlined />,
                            },
                        ]}
                    />
                );

                return (
                    <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
                        <Button icon={<VerticalDotsIcon />} />
                    </Dropdown>
                );
            },
        },
    ];


    const renderActions = (_, record) => {
        const canViewOffers = ListStatusGuard.canFinalValidate(record.status);

        const menu = (
            <AntMenu
                onClick={({ key }) => handleMenuClick(key, record)}
                items={[
                    {
                        key: 'vezi',
                        label: 'Vezi oferte',
                        icon: <EyeOutlined />,
                        disabled: !canViewOffers,
                    },
                    {
                        key: 'descarca',
                        label: 'Descarcă PDF-urile',
                        icon: <DownloadOutlined />,
                    },
                    {
                        key: 'printeaza',
                        label: 'Printează PDF-urile',
                        icon: <PrinterOutlined />,
                    },
                ]}
            />
        );

        return (
            <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
                <Button icon={<VerticalDotsIcon />} />
            </Dropdown>
        );
    };

    const tableColumns = listColumns.map((column) =>
        column.key === 'actions' ? { ...column, render: renderActions } : column
    );

    const MobileList = () => {
        const dataSource = searchQuery ? searchResults : lists;

        if (dataSource.length === 0) {
            return (
                <div className="list__empty-state">
                    <p className="list__empty-state-text">Nicio listă găsită.</p>
                </div>
            );
        }

        return (
            <div className="list__mobile-table-wrapper">
                <div className="list__mobile-table-header">
                    <div className="list__mobile-table-header-cell" style={{ width: '60px', flexShrink: 0 }}>Nr</div>
                    <div className="list__mobile-table-header-cell list__mobile-table-header-name">Status</div>
                    <div className="list__mobile-table-header-cell" style={{ width: '100px', flexShrink: 0 }}>Ofertate</div>
                    <div className="list__mobile-table-header-cell list__mobile-table-header-actions" style={{ width: '60px', flexShrink: 0 }}>Opt</div>
                </div>
                <div className="list__mobile-list">
                    {dataSource.map((row) => (
                        <div key={row.id} className="list__mobile-card">
                            <div className="list__mobile-card-cell" style={{ width: '60px', flexShrink: 0 }}>{row.id}</div>
                            <div className="list__mobile-card-cell list__mobile-card-name">
                                <StatusTag status={row.status} />
                            </div>
                            <div className="list__mobile-card-cell" style={{ width: '100px', flexShrink: 0 }}>
                                {(row.bidding_stats?.items_with_bids || 0)} / {(row.bidding_stats?.total_items || 0)}
                            </div>
                            <div className="list__mobile-card-cell list__mobile-card-actions" style={{ width: '60px', flexShrink: 0 }}>
                                {renderActions(null, row)}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <div className='standard products list'>
            <Header />


            <div className='standard__container list'>
                <Menu />
                <div className='standard__wrapper'>
                    <div style={{ padding: 24, minHeight: 280 }}>
                        <h2 className='standard__page-title'>Liste arhivate</h2>
                        <h4 className='standard__page-info'>
                            Aici urmaresti listele ofertate, poti extrage produsele fara oferte si analiza usor optiunile primite.
                        </h4>

                        <div className='list__search-box'>
                            <Search
                                className="list__search-input"
                                placeholder="Caută lista..."
                                onChange={(e) => handleSearch(e.target.value)}
                                value={searchQuery}
                                enterButton
                                allowClear
                            />

                        </div>
                        <div className='list__tabs-wrapper'>
                            <AntMenu
                                mode="horizontal"
                                selectedKeys={[selectedMenuKey]}
                                style={{ marginTop: 16 }}
                                onClick={(e) => {
                                    switch (e.key) {
                                        case 'creeaza':
                                            navigate('/liste-necesar');
                                            break;
                                        case 'gata':
                                            navigate('/gata-de-trimis');
                                            break;
                                        case 'ofertare':
                                            navigate('/liste-in-ofertare');
                                            break;
                                        case 'ofertate':
                                            navigate('/liste-ofertate');
                                            break;
                                        case 'procesareManuala':
                                            navigate('/procesare-manuala');
                                            break;
                                        case 'arhivate':
                                            navigate('/liste-arhivate');
                                            break;
                                        default:
                                            break;
                                    }
                                }}
                            >
                                <AntMenu.Item key="creeaza">Creează listă</AntMenu.Item>
                                <AntMenu.Item key="gata">
                                    Gata de trimis ({counts.ready_to_send || 0})
                                </AntMenu.Item>
                                <AntMenu.Item key="ofertare">
                                    Liste în ofertare ({counts.offering || 0})
                                </AntMenu.Item>
                                <AntMenu.Item key="ofertate">
                                    Liste ofertate ({counts.offered || 0})
                                </AntMenu.Item>
                                <AntMenu.Item key="procesareManuala">
                                    Procesare manuala ({counts.manual_processing || 0})
                                </AntMenu.Item>
                                <AntMenu.Item key="arhivate">
                                    Liste arhivate ({counts.archived || 0})
                                </AntMenu.Item>
                            </AntMenu>
                        </div>


                        <div className="list__table-wrapper">

                            <div className='list__table-content'>
                                {!isMobile ? (
                                    <Table
                                        dataSource={searchQuery ? searchResults : lists}
                                        columns={tableColumns}
                                        rowKey="id"
                                        pagination={false}
                                        scroll={{ x: true }}
                                    />
                                ) : (
                                    <MobileList />
                                )}
                            </div>
                        </div>


                    </div>
                </div>
            </div>


        </div>
    );
};

export default ArchivedLists;